import { render, staticRenderFns } from "./Fixing.vue?vue&type=template&id=067978fb&"
import script from "./Fixing.vue?vue&type=script&lang=js&"
export * from "./Fixing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports